<template>
    <div>
        <!-- PC 상단  -->
        <div class="lg:flex max-w-7xl h-[468px] w-full justify-between mx-auto items-center hidden">
            <div class="flex flex-col lg:ml-[80px] justify-center shrink-0">
                <img class="w-[152px]" src="@/assets/ic-lw-logo.png" alt="qmeet-logo">
                <div class="mt-5 font-bold text-[44px] text-text-0 leading-[52px] tracking-[-0.0045em]">
                    <p>개발뿐만 아니라 품질까지<br />
                        완성도에 신경쓰는 전문 개발사</p>
                </div>
                <div class="mt-2 text-content-size text-gray leading-[145%] tracking-[-0.0045em]">
                    <p>초기 설계부터 개발까지 고객 의도와 품질의<br />
                        안정성을 최우선으로 개발하는 리드워크입니다.</p>
                </div>
                <a href="https://www.q-meet.com/customer-case/11" target="_blank" rel="noopener noreferrer"
                    class="w-[210px] rounded-full items-center justify-center bg-main-0 py-4 cursor-pointer mt-4 block text-center">
                    <p class="font-medium text-white">리드워크 인터뷰 보기 →</p>
                </a>
            </div>
            <img class="w-[640px] h-[388px] shrink" src="@/assets/images/sw/sw_dev.png" alt="">
        </div>

        <!-- 모바일 상단  -->
        <div class="h-auto flex flex-col px-5 pb-10 mx-auto lg:hidden">
            <img class="w-[152px]" src="@/assets/ic-lw-logo.png" alt="qmeet-logo">
            <div class="mt-5 text-text-0 font-bold text-medium-size-2 leading-[145%] tracking-[-0.0045em]">
                <p>개발뿐만 아니라 품질까지 <br />
                    완성도에 신경쓰는 전문 개발사</p>
            </div>
            <div class="mt-2 leading-[145%] tracking-[-0.0045em] text-gray font-medium">
                <p>초기 설계부터 개발까지 고객 의도와 품질의<br />
                    안정성을 최우선으로 개발하는 리드워크입니다.</p>
            </div>
            <a href="https://www.q-meet.com/customer-case/11" target="_blank" rel="noopener noreferrer"
                class="w-[180px] rounded-full flex items-center justify-center bg-main-0 cursor-pointer mt-4 py-3 text-center">
                <p class="font-medium text-white text-small-size-1">리드워크 인터뷰 보기 →</p>
            </a>
            <img class="w-full max-w-xl mt-10 object-contain" style="aspect-ratio: 640/388;"
                src="@/assets/images/sw/sw_dev.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'TestingServiceHero'
}
</script>
